import { Bot, Zap, TrendingUp, Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const AiCodingHeroSection = () => {
  return (
    <section className="pt-24 pb-8 sm:pt-28 sm:pb-10">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Badge variant="outline" className="text-primary border-primary/30 bg-primary/5">
          <Bot className="w-3 h-3 mr-1" />
          AI Development
        </Badge>
        <Badge variant="outline" className="text-muted-foreground border-border">
          12 min read
        </Badge>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-foreground leading-tight mb-4">
        AI Coding Assistants:{" "}
        <span className="text-primary">Complete Comparison Guide</span>
      </h1>

      <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mb-8">
        In-depth comparison of the best AI coding tools in 2026. Features, pricing, strengths, 
        and which one to choose for your workflow.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Users className="w-6 h-6 text-primary mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">92%</div>
          <div className="text-sm text-muted-foreground">Devs use AI tools</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Zap className="w-6 h-6 text-chart-2 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">55%</div>
          <div className="text-sm text-muted-foreground">Productivity boost</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <TrendingUp className="w-6 h-6 text-chart-4 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">$10-20</div>
          <div className="text-sm text-muted-foreground">Monthly cost</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Bot className="w-6 h-6 text-chart-1 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">6+</div>
          <div className="text-sm text-muted-foreground">Top tools compared</div>
        </div>
      </div>
    </section>
  );
};
